import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import webSocket from '@/sockets/socket';

class RequestAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Business';
  controllerName = 'Requests';

  //Đường dẫn api
  getRequestByFilter = 'list-request';
  rejectRequests = 'reject';

  //danh sách request
  listLicense = 'list-license';

  listRequestApprove = 'list-request-approve';
  createdRequest = 'employee-created';

  /**
   * Lấy danh sách request có filter
   */
  async getListRequest(model, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.getRequestByFilter].join('/'),
      data: model,
    };
    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Lấy danh sách request có filter
   */
  async getListRequestNeedApprove(model, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.listRequestApprove].join('/'),
      data: model,
    };
    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Approve & Reject request
   */
  async rejectRequest(model) {
    let request = {
      url: [this.getAPIUrl(), this.rejectRequests].join('/'),
      data: model,
    };

    var res = httpClient.postAsync(request);

    return res;
  }

  async getEmployeeCreatedRequest() {
    let request = {
      url: [this.getAPIUrl(), this.createdRequest].join('/'),
    };

    var res = httpClient.getAsync(request);

    return res;
  }
}

export default new RequestAPI();
